import getPieveActivityEventText from '@/lib/activityEvents/getPieveActivityEventText.js';
import isAssistantBubbleEvent from '@/lib/activityEvents/isAssistantBubbleEvent.js';

const shouldPreserveExistingEventLines = ({ existingEvent, incomingEvent, assistantBubbleOnly = false }) => {
  if (assistantBubbleOnly) {
    const existingIsAssistantBubble = isAssistantBubbleEvent(existingEvent);
    const incomingIsAssistantBubble = isAssistantBubbleEvent(incomingEvent);

    if (!existingIsAssistantBubble && !incomingIsAssistantBubble) {
      return false;
    }
  }

  if (isAssistantBubbleEvent(existingEvent) || isAssistantBubbleEvent(incomingEvent)) {
    if (incomingEvent?.assistantTextFinal === true) {
      return false;
    }

    if (existingEvent?.assistantTextFinal === true) {
      return true;
    }
  }

  const existingText = getPieveActivityEventText(existingEvent);
  const incomingText = getPieveActivityEventText(incomingEvent);

  if (!existingText) {
    return false;
  }

  if (!incomingText) {
    return true;
  }

  return existingText.length > incomingText.length;
};

export default shouldPreserveExistingEventLines;
